var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 10,
    fill: "#FCD116"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 30,
    height: 5,
    fill: "#003893"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 30,
    height: 5,
    fill: "#CE1126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo);
export default __webpack_public_path__ + "static/media/co.ec0abe7dba4f842c8704f4b4913c7e2e.svg";
export { ForwardRef as ReactComponent };